import React from 'react';
import * as styles from './Header.module.scss';
import logo from '../../images/logo.png';
import clsx from 'clsx';
import Nav from '../Nav/Nav';
import { Link } from 'gatsby';

export default function Header({ className }) {
  return(
    <section className={clsx(styles.header, className)}>
      <div className={styles.main}>
        <div>
          <Link to='/' className={styles.logo}>
            <img src={logo} alt='Delix logo'/>
          </Link>
        </div>
        <div className={styles.topMenu}>
          <span className={styles.item}>
            <Link to='/careers'
              target='_blank'>
              Careers
            </Link>
          </span>
          <span className={styles.item}>
            <Link to='mailto:info@delixtherapeutics.com'>
              Contact
            </Link>
          </span>
        </div>
      </div>
      <Nav />
    </section>
  )
}